import { OptionType } from '@evinced-private/ui-common';

import { IWebSdkTest } from 'src/apps/web-sdks/types/WebSdkDashboardServiceTypes';
import { ConfigurationLabel } from 'src/common/types/ConfigurationTypes';

import { extractLabelKey, getExistingLabelKeysFromRows } from '../../shared/helpers';

export const extractAvailableLabelTypes = (
	testRows: IWebSdkTest[],
	allLabels: ConfigurationLabel[]
): OptionType[] => {
	if (allLabels?.length === 0 || testRows?.length === 0) {
		return allLabels.map((label) => ({ value: label.label, label: label.label }));
	}

	const labelKeysInAllTests = new Set<string>();
	const allLabelKeys = new Set(
		testRows.flatMap((row) => {
			const keys = (row?.labels ?? []).map((label: string) => extractLabelKey(label));
			return keys.filter((key: string) => key.length > 0);
		})
	);

	for (const key of allLabelKeys) {
		const allTestsHaveKey = testRows.every((row) => {
			const existingKeys = getExistingLabelKeysFromRows([row]);
			return existingKeys.includes(key);
		});
		if (allTestsHaveKey) {
			labelKeysInAllTests.add(key);
		}
	}

	return allLabels
		.filter((label) => !labelKeysInAllTests.has(label.label.toLowerCase()))
		.map((label) => ({ value: label.label, label: label.label }));
};
